import { render, staticRenderFns } from "./ChartFilter.vue?vue&type=template&id=36b4023a&"
import script from "./ChartFilter.vue?vue&type=script&lang=js&"
export * from "./ChartFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports